// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qvpf","label":"styles_label__3RwMx"};